module.exports = __webpack_public_path__ + "img/nav5.bab32c05.png";